import {  createOrderRequest } from "api/Employee";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useCreateOrderRequest = () => {
    const queryClient = useQueryClient();

    return useMutation(createOrderRequest, {
        onSuccess: () => {
            toast.success("Created successfully!");
            queryClient.invalidateQueries('orderRequests')

        },
        onError: (error: any) => {

            if (error.response?.data?.message) {
                toast.error(error.response?.data?.message);
                return
            }
            if (error.response?.data?.error) {
                toast.error(error.response?.data?.error);
                return
            }
            toast.error("Something went wrong! Please try again later.");
        },
    })
}